module.exports = __webpack_public_path__ + "static/media/banner4.c29a3d22.jpg";